import React from "react";
import StructureReport from "../../../../dealercomps/agent-dashboard/dash-components/StructureReport";

/**
 * SalesReportTab component displays a StructureReport component for
 * Zawadi supplier, impersonating agent 10001.
 *
 * @returns {React.ReactElement} A React component that displays the report.
 */
export default function SalesReportTab() {
  return (
    <div>
      <StructureReport supplierPrettyName="Zawadi" />
    </div>
  );
}
